import React from "react";
import "../App.css"; // Assuming you have a CSS file named App.css for your styles

const LandingPage = () => {
  return (
    <div>
      <header className="header" data-header>
        <div className="container">
          <a href="#" className="logo">
            <img
              src="./YOUR_NORTH_STAR.svg"
              alt="Your North Star Logo"
              width="200"
              height="200"
            />
          </a>
        </div>
      </header>

      <main>{/* You can add other sections here as needed */}</main>
    </div>
  );
};

export default LandingPage;
